export default function translateLuggageCount({
  luggage20InchCount,
  luggage25InchCount,
  luggage27InchCount,
  luggage29InchCount,
}) {
  const textArr = [];

  if (luggage20InchCount) {
    textArr.push(`20 吋行李 ${luggage20InchCount} 件`);
  }

  if (luggage25InchCount) {
    textArr.push(`25 吋行李 ${luggage25InchCount} 件`);
  }

  if (luggage27InchCount) {
    textArr.push(`27 吋行李 ${luggage27InchCount} 件`);
  }

  if (luggage29InchCount) {
    textArr.push(`29 吋行李 ${luggage29InchCount} 件`);
  }

  return textArr.join('、');
}
